module.exports = __webpack_public_path__ + "808c45436d4e67ed9a599a29873382fe.pdf";